    import React, { useState } from 'react';
    import axios from 'axios';
    import Swal from 'sweetalert2';

    const SubirImagenPerfil = ({ dni, done,imagenPasada }) => {
        const [imagen, setImagen] = useState(null);
        const [preview, setPreview] = useState(null);
        const [subiendo, setSubiendo] = useState(false);

        const handleDrop = (e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            handleFile(file);
        };

        const handleFile = (file) => {
            if (file && file.type.startsWith('image/')) {
                setImagen(file);
                setPreview(URL.createObjectURL(file));
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Archivo inválido',
                    text: '❌ Solo se permiten archivos de imagen.',
                });
            }
        };

        const limpiarImagen = () => {
            setImagen(null);
            setPreview(null);
        };
        const handleBorrarImagen = async () => {
        if (!dni) return;

        const confirmar = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción eliminará la imagen del servidor.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, borrar',
            cancelButtonText: 'Cancelar',
        });

        if (!confirmar.isConfirmed) return;

        setSubiendo(true); // Desactiva el botón mientras se borra

        const username = process.env.REACT_APP_KEY;
        const password = process.env.REACT_APP_PASS;
        const token = btoa(`${username}:${password}`);

        try {
            const response = await axios.delete(
                `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/borrarImagen/${dni}`,
                {
                    headers: {
                        Authorization: `Basic ${token}`,
                    },
                }
            );

            if (response.data.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Imagen eliminada correctamente',
                    showConfirmButton: false,
                    timer: 1500,
                });
                limpiarImagen();
                done();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al eliminar la imagen',
                    text: response.data.message || 'Intente nuevamente.',
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error en la conexión',
                text: '❌ No se pudo conectar al servidor.',
            });
        } finally {
            setSubiendo(false); // Reactiva el botón
        }
    };

        const handleUpload = async () => {
            if (!imagen) return;

            setSubiendo(true); // desactiva el botón
            const formData = new FormData();
            formData.append('imagen', imagen);
            formData.append('dni', dni);
            const username = process.env.REACT_APP_KEY;
            const password = process.env.REACT_APP_PASS;
            const token = btoa(`${username}:${password}`);
            try {
                const response = await axios.post(
                    'https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/subirImagen',
                    formData,
                    {
                        headers: { 
                                Authorization: `Basic ${token}`,
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                if (response.data.ok) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Imagen subida correctamente',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    limpiarImagen();
                    done()
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al subir la imagen',
                        text: response.data.message || 'Intente nuevamente.',
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error en la conexión',
                    text: '❌ No se pudo conectar al servidor.',
                });
            } finally {
                setSubiendo(false); // vuelve a habilitar el botón
            }
        };

        return (
            <div
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                className="border-dashed border-2 p-4 rounded-lg text-center w-full max-w-md mx-auto bg-white shadow"
            >
                <img
                src={`https://wwwa.isepsantafe.net.ar/${imagenPasada}?t=${Date.now()}`}
                        
                        alt="Foto Cadete"
                        className="rounded-circle border"
                        style={{ height: "75px", width: "75px", cursor: "pointer" }}
                        onClick={() => handleBorrarImagen(dni)}
                    />
                <p className="mb-2 text-gray-700">Arrastrá una imagen o hacé clic para elegir una</p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFile(e.target.files[0])}
                    className="mb-2"
                />

                {preview && (
                    <div className="mb-4">
                        <img
                            src={preview}
                            alt="Vista previa"
                            style={{ maxWidth: '300px', maxHeight: '300px', objectFit: 'contain', margin: '0 auto' }}
                        />
                        <br />
                        <button
                            onClick={limpiarImagen}
                            className="mt-2 text-sm text-red-500 hover:underline"
                        >
                            Quitar imagen
                        </button>
                    </div>
                )}

                <button
                    onClick={handleUpload}
                    disabled={!imagen || subiendo}
                    className={`${imagen && !subiendo
                            ? 'btn btn-success'
                            : 'bg-gray-400 cursor-not-allowed'
                        } text-white px-4 py-2 rounded transition-colors`}
                >
                    {subiendo ? 'Subiendo...' : 'Subir imagen'}
                </button>
            </div>
        );
    };

    export default SubirImagenPerfil;
